import { render, staticRenderFns } from "./MissingReferences.vue?vue&type=template&id=084a9d62"
import script from "./MissingReferences.vue?vue&type=script&lang=js"
export * from "./MissingReferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports